import { Star as StarIcon } from '@otp/icons';
import { SVGProps } from 'react';

export const Star = ({
  isActive,
  ...props
}: SVGProps<SVGSVGElement> & { isActive: boolean }) => {
  return (
    <StarIcon
      {...props}
      className="scale-[1.3] p-[3px] hover:fill-[#FFC425]"
      fill={isActive ? '#FFC425' : undefined}
    />
  );
};
